import { createRoutine } from "../utils/routine.utils";
export var getGetDetailAction = function (params) {
    var entityName = params.entityName;
    return createRoutine("".concat(entityName, "_GET_DETAIL").toUpperCase());
};
